import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-alert',
  templateUrl: './modal-alert.component.html',
  styleUrls: ['./modal-alert.component.css']
})
export class ModalAlertComponent implements OnInit {
  @Input() header:string="Información";
  @Input() text:string;

  public viewHeader:number=1;

  constructor(private modalService: NgbModal) { }

  ngOnInit() {
    if(this.header.length===0) this.viewHeader = 0;
  }

  accept=()=> {
    this.modalService.dismissAll('accept');
  }
  
}
